<router-outlet></router-outlet>
<app-modal-generico [data]="modalData"></app-modal-generico>
<app-loading></app-loading>
<app-message></app-message>